export default function sendGtmEvent(eventType, eventName, eventParams) {
  if (typeof window === "undefined" || !window.dataLayer || !window.gtag) {
    return;
  }
  window.gtag(eventType, eventName, eventParams);
}